import React from "react";
import { PageHero } from "../components/PageShells";
import { motion } from "framer-motion";

const steps = [
  { n: "01", title: "Productie", desc: "Je zonnepanelen produceren stroom uit zonlicht overdag." },
  { n: "02", title: "Direct verbruik", desc: "Apparaten en huishouden verbruiken eerst eigen stroom." },
  { n: "03", title: "Opslag in batterij", desc: "Overschot wordt direct opgeslagen in je thuisbatterij." },
  { n: "04", title: "Gebruik 's avonds", desc: "Wanneer panelen niets meer leveren, ontlaadt de batterij." },
  { n: "05", title: "Slim energiebeheer", desc: "AI optimaliseert laden/ontladen op basis van dynamische prijzen." },
  { n: "06", title: "Net als backup", desc: "Pas als batterij leeg is, gebruik je het stroomnet." },
];

const Werking = () => (
  <main data-testid="how-page">
    <PageHero
      eyebrow="Werking"
      title="Zo werkt een slimme thuisbatterij."
      subtitle="In 6 stappen leggen we uit hoe je systeem 24/7 zorgt voor maximale eigen energie."
    />
    <section className="section-pad">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.05 }}
            className="bg-white rounded-3xl border border-slate-200 p-7 hover:border-brand/40 hover:-translate-y-1 transition-all duration-300"
          >
            <div className="font-heading text-5xl font-black gradient-pink-text mb-4">{s.n}</div>
            <h3 className="font-heading text-xl font-bold text-navy-900 mb-2">{s.title}</h3>
            <p className="text-slate-600">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  </main>
);

export default Werking;
